import React, { FC, Fragment } from 'react';
import moment from 'moment';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_PROCUREMENT_STATUS, ProcurementType } from 'models/procurement.model';
import ProcurementStatusTag from '../procurement-status-tag';
import useProcurementContext from 'contexts/procurement.context/context';
import { formatCurrency } from 'utils/functions';

type Props = {
  procurement: ProcurementType;
};

const ProcurementCard: FC<Props> = ({ procurement }) => {
  const { setProcurementToUpdate } = useProcurementContext();
  const order_code = procurement?.code;
  const router = useNavigate();
  const updateProcurement = () => {
    setProcurementToUpdate(procurement);
    procurement.status === ENUM_PROCUREMENT_STATUS.REJECTED
      ? router(`${MAIN_STORE_ROUTE_KEYS.PROCUREMENT}/update-rejected/${procurement.id}`)
      : router(`${MAIN_STORE_ROUTE_KEYS.PROCUREMENT}/update/${procurement.id}`);
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium  text-base cursor-pointer'>#{order_code}</h4>
            <ProcurementStatusTag type={procurement?.status} />
          </div>

          <div className='p-3 text-xs'>
            {procurement?.items?.map((item, i) => (
              <div key={i} className='flex  items-center '>
                <p className='font-[500]'>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className='text-xs text-gray-5'>
                  {' '}
                  {item.quantity} {item.ingredient?.unit_type} (
                  <span>{formatCurrency(item.price)}</span>)
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {moment(procurement?.created_at)?.format('Do MMM, YYYY [at] h:mm A')}</p>
          <Button
            className='text-xs'
            color='primary'
            variant='link'
            onClick={() => updateProcurement()}>
            View
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default ProcurementCard;
